import { FormGroup } from '@angular/forms';

export abstract class FormHelper {
	public form: FormGroup;
	public submitError = '';

	public abstract buildForm(): void;
	public abstract submitForm(): void;
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/helpers/form-helper.ts